import React, { Component } from "react";
import Button from "react-md/lib/Buttons";
import Card from "react-md/lib/Cards";
import CardTitle from "react-md/lib/Cards/CardTitle";
import TextField from "react-md/lib/TextFields";
import Snackbar from "react-md/lib/Snackbars";
import CircularProgress from "react-md/lib/Progress/CircularProgress";
import contact from "../../data/contact";
import "./contact.scss";

export default class ContactPage extends Component {
  constructor(props) {
    super(props);
    this.emailTest = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    this.state = {
      emailSent: false,
      sendingInProgress: false,
      toasts: [],
      errorState: {
        name: false,
        nameError: "",
        email: false,
        emailError: "",
        message: false,
        messageError: ""
      },
      name: "",
      email: "",
      message: ""
    };
  }

  addToast = text => {
    const toasts = this.state.toasts.slice();
    toasts.push({ text });
    this.setState({ toasts });
  };

  removeToast = () => {
    const [, ...toasts] = this.state.toasts;
    this.setState({ toasts });
  };

  sendEmail = () => {
    const { name, email, message } = this.state;
    this.setState({ sendingInProgress: true });
    const component = this;
    const xhr = new XMLHttpRequest();
    xhr.open("POST", `https://formspree.io/${contact.email}`);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onload = function() {
      if (xhr.status === 200) {
        component.setState({ emailSent: true });
      } else {
        component.addToast("Failed sending email. Please try again later.");
      }
    };
    xhr.send(
      JSON.stringify({
        name,
        email,
        message
      })
    );
  };
  validateName = name => {
    if (name === "") {
      this.setState({
        errorState: {
          name: true,
          nameError: "Name should not be empty."
        }
      });
      return false;
    } else {
      this.setState({
        errorState: { name: false }
      });
      return true;
    }
  };
  validateEmail = email => {
    if (!this.emailTest.test(email)) {
      this.setState({
        errorState: {
          email: true,
          emailError: "Invalid email address."
        }
      });
      return false;
    } else {
      this.setState({
        errorState: { email: false }
      });
      return true;
    }
  };
  validateMessage = message => {
    if (message === "") {
      this.setState({
        errorState: {
          message: true,
          messageError: "Message should not be empty."
        }
      });
      return false;
    } else {
      this.setState({
        errorState: { name: false }
      });
      return true;
    }
  };
  handleBtnClick = () => {
    const nameIsValid = this.validateName(this.state.name);
    const emailIsValid = this.validateName(this.state.email);
    const messageIsValid = this.validateName(this.state.message);
    if (nameIsValid && emailIsValid && messageIsValid) {
      this.sendEmail();
    } else {
      this.addToast("Invalid form fields. Please check your information.");
    }
  };
  handleNameChange = e => {
    this.setState({ name: e });
    this.validateName(e);
  };
  handleEmailChange = e => {
    this.setState({ email: e });
    this.validateEmail(e);
  };
  handleMessageChange = e => {
    this.setState({ message: e });
    this.validateMessage(e);
  };
  render() {
    const { emailSent, errorState } = this.state;

    const afterSending = (
      <div className="contact">
        <h1>Thanks for contacting us!</h1>
      </div>
    );
    const beforeSending = (
      <Card className="md-grid md-cell--8 contact-form">
        <CardTitle
          title="Contact Us"
          subtitle="We would love to hear from you!"
        />
        <TextField
          label="Name"
          placeholder="Your name"
          id="name"
          type="text"
          value={this.state.name}
          error={errorState.name}
          errorText={errorState.nameError}
          onChange={this.handleNameChange}
        />
        <TextField
          label="Email"
          placeholder="Your email address"
          error={errorState.email}
          errorText={errorState.emailError}
          value={this.state.email}
          type="email"
          id="email"
          onChange={this.handleEmailChange}
        />
        <TextField
          label="Message"
          rows={3}
          maxRows={20}
          placeholder="Your message"
          error={errorState.message}
          errorText={errorState.messageError}
          value={this.state.message}
          onChange={this.handleMessageChange}
          id="message"
        />
        <div className="submit-container md-grid--no-spacing">
          {this.state.sendingInProgress
            ? <CircularProgress
                centered={false}
                id="progress"
                className="md-cell--left"
              />
            : null}
          <Button
            label="Submit"
            secondary
            raised
            onClick={this.handleBtnClick}
            className="md-cell--right"
          />
        </div>
        <Snackbar toasts={this.state.toasts} onDismiss={this.removeToast} />
      </Card>
    );
    return emailSent ? afterSending : beforeSending;
  }
}



// WEBPACK FOOTER //
// ./src/pages/contact.jsx